<template>
    <div class="context" @click.stop="toggleMenu">
        <Icon ref="icon" class="ico" name="more-horizontal" color="accent" data-cy="contextOpen" />
        <div :class="'menu' + (menuOpen ? ' open' : '')" data-cy="context">
            <slot />
        </div>
    </div>
</template>

<script>
import Icon from '@/components/FeatherIcon'

export default {
    name: 'DContextMenu',
    components: { Icon },
    description: 'Context menu',
    note: 'Use this together with DContextMenuItem',
    token: '<DContextMenu/>',
    data() {
        return {
            menuOpen: false,
        }
    },
    mounted() {
        window.v.$el.addEventListener('click', this.close)
    },
    beforeDestroy() {
        window.v.$el.removeEventListener('click', this.close)
    },
    methods: {
        toggleMenu() {
            this.menuOpen = !this.menuOpen
        },
        close(e) {
            if (!e.composedPath().includes(this.$refs['icon'].$el)) this.menuOpen = false
        },
    },
}
</script>

<style scoped lang="sass">
.context
    position: relative

    .ico
        &:hover
            cursor: pointer

    .menu
        display: none
        padding: $xxs $xxs
        border-radius: 3px
        box-shadow: 0 2px 10px rgba(33, 43, 54, 0.08)
        position: absolute
        z-index: 1
        top: 100%
        right: 0
        background: white

    .open
        display: inline-block
</style>
